module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_5.16c023ef.png";